import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

const useViewerCompanyIdEffective = () => {
    const [viewerCompanyId, setViewerCompanyId] = useState();
    const { viewer } = useViewer();

    useEffect(() => {
        if (!viewer) {
            return;
        }

        if (!viewer.deferredCompany && !viewer.company) {
            setViewerCompanyId(null);
            return;
        }

        if (viewer.deferredCompany?.recordId) {
            setViewerCompanyId(viewer.deferredCompany.recordId);
            return;
        }

        setViewerCompanyId(viewer.company.recordId);
    }, [viewer]);

    return { viewerCompanyId };
};

export default useViewerCompanyIdEffective;
